import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button, message } from "antd";
import logo from "../../../Assets/Images/Logo.svg";
import success from "../../../Assets/Icons/success.svg";
import "./style.css";
import { verifyEmail } from "../../../API/auth";

const VerifiedSuccessfully = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const verifyUserEmail = async () => {
      setLoading(true);

      const res = await verifyEmail(id);

      if (res?.status === 200) {
        message.success("Email verified successfully!");
      } else {
        message.error(
          res?.data?.detail || "Verification failed. Link may be invalid."
        );
      }

      setLoading(false);
    };

    if (id) {
      verifyUserEmail();
    }
  }, [id]);

  const handleBack = () => {
    navigate("/login");
  };

  return (
    <div className="verified">
      <div className="verified-page">
        <div className="logo">
          <img src={logo} alt="logo" />
        </div>

        <div className="verified-card">
          {loading ? (
            <div className="content-heading">Verifying your email...</div>
          ) : (
            <>
              <div className="email-logo">
                <img src={success} alt="success" />
              </div>

              <div className="content-heading">Email Verified Successfully</div>

              <div className="sub-heading">
                Your account is now fully activated. You can now start
                integrating our Email API into your applications.
              </div>

              <Button
                type="primary"
                className="submit-button"
                loading={loading}
                onClick={handleBack}
              >
                Back To Login
              </Button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifiedSuccessfully;
